











import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class RenderImage extends Vue {
  @Prop({type: String, default: null}) src?: string | null
  @Prop({type: String, default: null}) alt?: string | null

  openImageDisplay() {
    const {src, alt} = this
    if (src) {
      this.$modal.open('imageDisplay', {src, alt})
    }
  }
}
